export const ArrowRed = ({ width = 16, height = 16, color = "#F0552D" }) => (
    <div
        style={{
            padding: "2px",
            width,
            height,
        }}
    >
        <svg
            width={width}
            height={height}
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 6L8 11L4 6H12Z"
                fill={color}
            />
        </svg>
    </div>
);
